import { gql } from '@apollo/client';

export const ALL_INTERVENTION_TYPES = gql`
  query AllInterventionTypes {
    getInterventionTypes {
      id
      name
    }
  }
`;
